var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgExcelFileBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.771,
    height: 18.871,
    viewBox: "0 0 14.771 18.871"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-excel-file-blue_svg__cls-2,.kpmg-excel-file-blue_svg__cls-4{fill:none;stroke-linecap:round;stroke:#0091da}.kpmg-excel-file-blue_svg__cls-2{stroke-width:1.3px}.kpmg-excel-file-blue_svg__cls-4{stroke-width:1.6px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-excel-file-blue_svg__ICN_Fisier_excel_Enabled",
    "data-name": "ICN_Fisier excel_Enabled",
    transform: "translate(-421.241 -404.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-excel-file-blue_svg__Group_698",
    "data-name": "Group 698",
    transform: "translate(421.891 404.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-excel-file-blue_svg__Group_611",
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-excel-file-blue_svg__Path_823",
    "data-name": "Path 823",
    d: "M3.646 0h6.179l3.646 3.646v10.279a3.646 3.646 0 01-3.646 3.646H3.646A3.646 3.646 0 010 13.925V3.646A3.646 3.646 0 013.646 0z",
    strokeWidth: 1.3,
    strokeLinejoin: "round",
    stroke: "#0091da",
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-excel-file-blue_svg__Path_822",
    "data-name": "Path 822",
    className: "kpmg-excel-file-blue_svg__cls-2",
    d: "M0 .6v3.615",
    transform: "translate(9.57 -.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-excel-file-blue_svg__Line_62",
    "data-name": "Line 62",
    className: "kpmg-excel-file-blue_svg__cls-2",
    transform: "translate(9.57 3.752)",
    d: "M0 0h3.646"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-excel-file-blue_svg__Group_2242",
    "data-name": "Group 2242",
    transform: "translate(3.973 5.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-excel-file-blue_svg__Line_619",
    "data-name": "Line 619",
    className: "kpmg-excel-file-blue_svg__cls-4",
    d: "M0 0l5.808 8.086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-excel-file-blue_svg__Line_620",
    "data-name": "Line 620",
    className: "kpmg-excel-file-blue_svg__cls-4",
    d: "M0 8.086L5.808 0"
  }))))));
}

export default SvgKpmgExcelFileBlue;